<template>
  <div class="Page Marker">
    <canvas class="Marker__canvas" ref="canvas" />
    <canvas class="Marker__spritesheet_canvas" ref="spritesheet_canvas" />
    <keep-alive :include="['Trone', 'Card']">
      <Comp v-if="ready && phaserReady" :found="found" ref="marker" :is="$route.params.marker" />
    </keep-alive>
    <Capture :found="isFound" />
    <div class="Marker__loading" v-if="!ready">
      <div class="Marker__loading-text" v-html="trans('loading')" />
    </div>

  </div>
</template>

<script>
import Page from '@/core/mixins/Page'
import Capture from '@/components/capture/Capture'
import Singer from './markers/singer/Singer'
import Card from './markers/card/Card'
// import Trone from './markers/trone/Trone'
import Crown from './markers/crown/Crown'

export default {
  name: 'MarkerAr',
  mixins: [Page],
  components: { Crown, Singer, Trone, Card, Capture },
  data: () => ({
    ready: false,
    raf: null,
    phaserReady: false,
    found: false,
    image: null,
    forceFound: false,
  }),
  translations: {
    fr: { loading: 'Chargement...' },
    en: { loading: 'Loading...' },
  },
  computed: {
    isFound() { return this.forceFound ? true : this.found }
  },
  activated() {
    TweenMax.to(this.$el, 1, { alpha: 1 })
    if(this.ready) {
      XR.resume()
			navigator.mediaDevices.getUserMedia({ video: { frameRate: 30, facingMode: 'environment' } }).then(stream => {
			  const video = this.$el.querySelector('video')
				video.srcObject = stream
				video.play()
			})
    }
    this.animate()
  },
  deactivated() {
    XR.pause()
    TweenMax.to(this.$el, 1, { alpha: 0 })
    const video = this.$el.querySelector('video')
		_.each(video.srcObject.getTracks(), track => track.stop())
    cancelAnimationFrame(this.raf)
  },
  watch: {
    found() {
      if(this.found)
        this.$store.commit('user/SET_MARKER', this.$route.params.marker)
    }
  },
  mounted() {
    this.initXR()
    this.initPhaser()
    this.$clock = new THREE.Clock()
  },
  methods: {
    initPhaser() {
      const _this = this
      this.$game = new Phaser.Game({
        type: 1,
        width: 512,
        height: 512,
        canvas: this.$refs.spritesheet_canvas,
        render: { transparent: true },
        scene: {
          preload() {
            this.load.multiatlas('trone_1', '/dist/trone/trone_1.json', '/dist/trone')
            this.load.multiatlas('trone_2', '/dist/trone/trone_2.json', '/dist/trone')
            this.load.multiatlas('card_1', '/dist/card/card_1.json', '/dist/card')

            const texture = new THREE.CanvasTexture(_this.$refs.spritesheet_canvas)
            texture.minFilter = THREE.LinearFilter
            texture.magFilter = THREE.LinearFilter
            const material = new THREE.MeshBasicMaterial({ map: texture, side: THREE.DoubleSide, transparent: true })
            const model = new THREE.Mesh(new THREE.PlaneGeometry(5, 5), material)
            TweenMax.set(model, { three: { rotationX: 0 } })

            _this.$model_spritesheet = model
            _this.$texture = texture

            _this.$sprite_trone = this.add.sprite(250, 250)
            _this.$sprite_card = this.add.sprite(250, 250)

            _this.$sprite_trone.visible = false
            _this.$sprite_card.visible = true

            _this.phaserReady = true
          },
          create() {
            _.each(['trone_1', 'trone_2', 'card_1'], name => {
              this.anims.create({
                key: name,
                frames: this.anims.generateFrameNames(name),
                frameRate: 30,
                repeat: -1,
                yoyo: true
              })
            })

            console.log('PHASER LOADED')
          }
        }
      })
    },
    initXR() {
      XR.xrController().configure({ disableWorldTracking: true })
      XR.addCameraPipelineModules([  // Add camera pipeline modules.
        XR.GlTextureRenderer.pipelineModule(),       // Draws the camera feed.
        XR.Threejs.pipelineModule(),                 // Creates a ThreeJS AR Scene.
        XR.XrController.pipelineModule(),            // Enables SLAM tracking.
        XR.canvasScreenshot().cameraPipelineModule(),
        // XRExtras.AlmostThere.pipelineModule(),       // Detects unsupported browsers and gives hints.
        XRExtras.FullWindowCanvas.pipelineModule(),  // Modifies the canvas to fill the window.
        // XRExtras.Loading.pipelineModule(),           // Manages the loading screen on startup.
        // XRExtras.RuntimeError.pipelineModule(),      // Shows an error image on runtime error.
        this.create(),                  // Draws a frame around detected image targets.
      ])

      XR.run({canvas: this.$refs.canvas})
    },
    create() {
      const onStart = ({canvasWidth, canvasHeight}) => {
        const {camera} = XR.Threejs.xrScene()
        this.$scene = XR.Threejs.xrScene().scene
        this.$stage = new THREE.Group()
        this.$scene.add(this.$stage)

        this.$scene.add(new THREE.PointLight(0xffffff, 1, 10000))
        this.$scene.add(new THREE.AmbientLight(0xFFFFFFF, 100))

        camera.position.set(0, 3, 0)
        XR.XrController.updateCameraProjectionMatrix({
          origin: camera.position,
          facing: camera.quaternion,
        })
        this.ready = true
      }

      const onFound = (e) => {
        // if(e.detail.name != this.$route.params.marker) return
        this.found = true
        showImageFrame(e)
      }

      const showImageFrame = (e) => {
        const detail = e.detail
        this.$stage.position.copy(detail.position)
        this.$stage.quaternion.copy(detail.rotation)
        this.$stage.scale.set(detail.scale, detail.scale, detail.scale)
        this.$stage.visible = true
      }

      const hideImageFrame = (e) => {
        this.$stage.visible = false
        this.found = false
      }

      return {
        name: 'targetframes',
        onStart,
        listeners: [
          {event: 'reality.imagefound', process: onFound},
          {event: 'reality.imageupdated', process: showImageFrame},
          {event: 'reality.imagelost', process: hideImageFrame},
        ],
      }
    },
    animate() {
      this.raf = requestAnimationFrame(this.animate)

			if(!this.ready) return

      const delta = this.$clock.getDelta()

      if(this.$texture && this.found && (this.$route.params.marker == 'trone' || this.$route.params.marker == 'card'))
        this.$texture.needsUpdate = true

      if(this.$refs.marker && typeof this.$refs.marker.animate == 'function')
        this.$refs.marker.animate(delta)
    }

  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Marker
  height 100%
  text-align center

  &__loading
    position absolute
    color gold
    background black
    top 0px
    left 0px
    right 0px
    bottom 0px
    z-index 99
    &-text
      position absolute
      top 50%
      transform translateY(-50%)
      text-align center
      width 100%

  &__spritesheet_canvas
    position absolute
    left 0px
    right 0px
    z-index 99
    display none

  video
    z-index 0

  &__canvas
    width 100%
    height 100%
    position absolute
    top 0
    left 0

</style>
